// You can customize the template with the help of this file

import appUtils from "../sp-utils/app.utils";

//Template config options
const themeConfig = {
  app: {
    appName: "eQomply",
    appLogoImage: require("@src/assets/images/logo/eqomply-light.png"), //.default,
    appLogoDark: require("@src/assets/images/logo/eqomply-logo-dark.png"),
  },
  layout: {
    isRTL: false,
    skin: "semi-dark", // light, dark, bordered, semi-dark
    routerTransition: "fadeIn", // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: "vertical", // vertical, horizontal
    contentWidth: "boxed", // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "floating", // static , sticky , floating, hidden
      backgroundColor: "light", //appUtils.isProd() ? "light" : "danger", // BS color options [primary, success, etc]
    },
    footer: {
      type: "sticky", // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true, // Enable scroll to top button
  },
};

export default themeConfig;
